
import {SetShare} from "../../utils/wx"
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"

export default {
name: 'Meeting-list',
components: {
XButton,
Divider
},
filters: {
/**
* @return {string}
*/
MeetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
}

},
data () {
return {
Meeting:{},
MeetingID: 0,
show:false,
SubMeetingDescMap: {},
PositionMap: {
"chairman": "主委员",
"vice_chairman": "副委员",
"secretary_general": "秘书长",
"secretary": "秘书"
},
MemberUser: {},
isMemberValid: false
}
},
async created () {
this.MeetingID = this.$route.params["id"]
if (!this.MeetingID) this.$router.go(-1)
this.MeetingID = parseInt(this.MeetingID)
await this.fetchMeetingDetail()
},
methods: {
ParseTime,
async fetchMeetingDetail() {
let res = await Api('GetMeetingList',{
Data:{
ID:this.MeetingID,
},
Preloads:[
{Column:'SubMeetings'},
{Column:'MeetingImages'}
]

})
if (res.data.List && res.data.List.length == 1) {
this.Meeting = res.data.List[0]
} else {
this.$vux.toast.show({
text:'获取会议信息出错',
type:'cancel',
})
this.$router.go(-1)
}

SetShare({
url: window.location.href,
image: this.Meeting.HeadImg,
title: this.Meeting.Tittle,
desc: `开始时间：${ParseTime(this.Meeting.StartAt,'{y}-{m}-{d}')}
结束时间：${ParseTime(this.Meeting.EndAt,'{y}-{m}-{d}')}
举办地：${this.Meeting.HoldingCity}`
})
},
handleToEnroll() {
if (this.Meeting.MeetingType === 'conference') {
this.$router.push(`/order/new/${this.MeetingID}`)
} else if (this.Meeting.MeetingType === 'training') {
this.$router.push(`/order/new-training/${this.MeetingID}`)
} else {
this.$vux.toast.show({
text:'会议类型错误',
type:'cancel',
})
}

},
handleClickSub(id) {
this.$set(this.SubMeetingDescMap,id,!this.SubMeetingDescMap[id])
},
}
}
